<template>
  <div class="custmor_form_side">
    <div class="custmor_form_fixed">
      <div class="custmor_form_logo">
        <div>
          <img class="custmor_form_logo_style" src="../src/assets/logo.png" alt="" srcset="">
        </div>
        <div class="custmor_form_logo_title">医師モニター評価サービス事業</div>
      </div>
      <div class="custmor_form_content">
        <div>
          <div class="custmor_form_head_banner">
          </div>
          <div class="custmor_form_head_title">
            CGM Medical参加申し込みフォーム登録書
          </div>
        </div>
        <div class="custmor_form_body">
          <div class="custmor_form_body_widget">
            <div>
              <el-checkbox v-model="custmor_form.doctorRecommend" :false-label="0" :true-label="1">医師推奨マーク
              </el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="custmor_form.doctorProducer" :false-label="0" :true-label="1">医師監修サービス
              </el-checkbox>
            </div>
          </div>
          <div class="custmor_form_body_widget2">
            <div>会社名</div>
            <el-input v-model="custmor_form.companyName"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>会社名フリガナ</div>
            <el-input v-model="custmor_form.companyNameKana"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>本社所在地</div>
            <!-- <el-cascader :options="some_options" placeholder="選択してください" @change="address_change">
            </el-cascader> -->
            <!-- <el-cascader v-model="cascader_array" :options="level1_array" :props="props"
              placeholder="選択してください"></el-cascader> -->
            <el-select v-model="level1_item" placeholder="都道府県" @change="level1_change">
              <el-option v-for="item in level1_array" :key="item.name1" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level2_item" placeholder="市町村" @change="level2_change">
              <el-option v-for="item in level2_array" :key="item.name2" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="date_separator_style">/</span>
            <el-select v-model="level3_item" placeholder="町">
              <el-option v-for="item in level3_array" :key="item.name3" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="custmor_form_body_widget2">
            <div>詳細な住所</div>
            <el-input v-model="custmor_form.companyAddressDetail"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>代表電話番号</div>
            <el-input v-model="custmor_form.companyPhone"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>メールアドレス</div>
            <el-input v-model="custmor_form.companyEmail"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>担当者名</div>
            <el-input v-model="custmor_form.commanderName"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>担当者部署</div>
            <el-input v-model="custmor_form.commanderDepartment"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>担当者電話番号</div>
            <el-input v-model="custmor_form.commanderPhone"></el-input>
          </div>
          <div class="custmor_form_body_widget2">
            <div>担当者メールアドレス</div>
            <el-input v-model="custmor_form.commanderEmail"></el-input>
          </div>
        </div>
        <div class="custmor_form_widget_line"></div>
        <div class="custmor_form_footer">
          <el-button type="success" @click="custmor_form_submit">送信</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  mounted() {
    this.address_init();
  },
  data() {
    return {
      level1_item: null,
      level2_item: null,
      level3_item: null,
      level1_array: [],
      level2_array: [],
      level3_array: [],
      cascader_array: [],
      custmor_form: {
        doctorRecommend: 0,
        doctorProducer: 0,
        companyName: null,
        companyNameKana: null,
        companyAddress: null,
        companyAddressDetail: null,
        companyPhone: null,
        companyEmail: null,
        commanderName: null,
        commanderDepartment: null,
        commanderPhone: null,
        commanderEmail: null,
      },
      props: {
        lazy: true,
        // this指向
        // leaf 叶子节点
        lazyLoad: ((node, resolve) => {
          if (node.level == 1) {
            this.axios.get('/level2/list', {
              params: {
                name1: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
          if (node.level == 2) {
            this.axios.get('/level3/list', {
              params: {
                name2: node.value
              }
            }).then((res) => {
              resolve(res.data.data);
            }).catch((error) => {
              console.log(error);
            })
          }
        }),
      },
      some_options: [
        {
          value: "北海道",
          label: "北海道",
          children: [
            {
              value: "北海道",
              label: "北海道",
              children: [
                {
                  value: "北海道",
                  label: "北海道",
                },
              ],
            },
          ],
        },
        {
          value: "東北地方",
          label: "東北地方",
          children: [
            {
              value: "東北地方",
              label: "東北地方",
              children: [
                {
                  value: "青森",
                  label: "青森",
                },
                {
                  value: "岩手",
                  label: "岩手",
                },
                {
                  value: "宮城",
                  label: "宮城",
                },
                {
                  value: "秋田",
                  label: "秋田",
                },
                {
                  value: "山形",
                  label: "山形",
                },
                {
                  value: "福島",
                  label: "福島",
                },
              ],
            },
          ],
        },
        {
          value: "関東地方",
          label: "関東地方",
          children: [
            {
              value: "関東地方",
              label: "関東地方",
              children: [
                {
                  value: "東京",
                  label: "東京",
                },
                {
                  value: "神奈川",
                  label: "神奈川",
                },
                {
                  value: "埼玉",
                  label: "埼玉",
                },
                {
                  value: "千葉",
                  label: "千葉",
                },
                {
                  value: "茨城",
                  label: "茨城",
                },
                {
                  value: "栃木",
                  label: "栃木",
                },
                {
                  value: "群馬",
                  label: "群馬",
                },
              ],
            },
          ],
        },
        {
          value: "中部地方",
          label: "中部地方",
          children: [
            {
              value: "中部地方",
              label: "中部地方",
              children: [
                {
                  value: "新潟",
                  label: "新潟",
                },
                {
                  value: "富山",
                  label: "富山",
                },
                {
                  value: "石川",
                  label: "石川",
                },
                {
                  value: "福井",
                  label: "福井",
                },
                {
                  value: "山梨",
                  label: "山梨",
                },
                {
                  value: "長野",
                  label: "長野",
                },
                {
                  value: "岐阜",
                  label: "岐阜",
                },
                {
                  value: "静岡",
                  label: "静岡",
                },
                {
                  value: "愛知",
                  label: "愛知",
                },
              ],
            },
          ],
        },
        {
          value: "近畿地方",
          label: "近畿地方",
          children: [
            {
              value: "近畿地方",
              label: "近畿地方",
              children: [
                {
                  value: "三重",
                  label: "三重",
                },
                {
                  value: "滋賀",
                  label: "滋賀",
                },
                {
                  value: "京都",
                  label: "京都",
                },
                {
                  value: "大阪",
                  label: "大阪",
                },
                {
                  value: "兵庫",
                  label: "兵庫",
                },
                {
                  value: "奈良",
                  label: "奈良",
                },
                {
                  value: "和歌山",
                  label: "和歌山",
                },
              ],
            },
          ],
        },
        {
          value: "中国・四国地方",
          label: "中国・四国地方",
          children: [
            {
              value: "中国・四国地方",
              label: "中国・四国地方",
              children: [
                {
                  value: "鳥取",
                  label: "鳥取",
                },
                {
                  value: "島根",
                  label: "島根",
                },
                {
                  value: "岡山",
                  label: "岡山",
                },
                {
                  value: "広島",
                  label: "広島",
                },
                {
                  value: "山口",
                  label: "山口",
                },
                {
                  value: "徳島",
                  label: "徳島",
                },
                {
                  value: "香川",
                  label: "香川",
                },
                {
                  value: "愛媛",
                  label: "愛媛",
                },
                {
                  value: "高知",
                  label: "高知",
                },
              ],
            },
          ],
        },
        {
          value: "九州・沖縄地方",
          label: "九州・沖縄地方",
          children: [
            {
              value: "九州・沖縄地方",
              label: "九州・沖縄地方",
              children: [
                {
                  value: "福岡",
                  label: "福岡",
                },
                {
                  value: "佐賀",
                  label: "佐賀",
                },
                {
                  value: "長崎",
                  label: "長崎",
                },
                {
                  value: "熊本",
                  label: "熊本",
                },
                {
                  value: "大分",
                  label: "大分",
                },
                {
                  value: "宮崎",
                  label: "宮崎",
                },
                {
                  value: "鹿児島",
                  label: "鹿児島",
                },
                {
                  value: "沖縄",
                  label: "沖縄",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    level1_change(e) {
      this.level2_item = null;
      this.level3_item = null;
      this.level2_array = [];
      this.level3_array = [];

      this.axios.get('/level2/list', {
        params: {
          name1: e
        }
      }).then((res) => {
        this.level2_array = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    level2_change(e) {
      this.level3_item = null;
      this.level3_array = [];

      this.axios.get('/level3/list', {
        params: {
          name2: e
        }
      }).then((res) => {
        this.level3_array = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    address_init() {
      this.axios.get('/level1/list', {
        // params: {
        //   ID: 12345
        // }
      }).then((res) => {
        this.level1_array = res.data.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    // address_change(arr) {
    //   this.custmor_form.companyAddress = arr[0] + '/' + arr[1] + '/' + arr[2]
    // },
    custmor_form_submit() {
      if (this.custmor_form.doctorRecommend == 0 && this.custmor_form.doctorProducer == 0) {
        this.$message({
          message: '医師推奨マーク 200万円 医師監修サービス 20万円',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.companyName == null || this.custmor_form.companyName == "") {
        this.$message({
          message: '会社名',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.companyNameKana == null || this.custmor_form.companyNameKana == "") {
        this.$message({
          message: '会社名フリガナ',
          type: 'warning'
        });
        return
      }
      // if (this.cascader_array.length != 3) {
      //   this.$message({
      //     message: '本社所在地',
      //     type: 'warning'
      //   });
      //   return
      // }
      if (this.level1_item == null) {
        this.$message({
          message: '都道府县',
          type: 'warning'
        });
        return
      }
      if (this.level2_item == null) {
        this.$message({
          message: '区市',
          type: 'warning'
        });
        return
      }
      if (this.level3_item == null) {
        this.$message({
          message: '町',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.companyAddressDetail == null || this.custmor_form.companyAddressDetail == "") {
        this.$message({
          message: '詳細な住所',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.companyPhone == null || this.custmor_form.companyPhone == "") {
        this.$message({
          message: '代表電話番号',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.companyEmail == null || this.custmor_form.companyEmail == "") {
        this.$message({
          message: 'メールアドレス',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.commanderName == null || this.custmor_form.commanderName == "") {
        this.$message({
          message: '担当者名',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.commanderDepartment == null || this.custmor_form.commanderDepartment == "") {
        this.$message({
          message: '担当者部署',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.commanderPhone == null || this.custmor_form.commanderPhone == "") {
        this.$message({
          message: '担当者電話番号',
          type: 'warning'
        });
        return
      }
      if (this.custmor_form.commanderEmail == null || this.custmor_form.commanderEmail == "") {
        this.$message({
          message: '担当者メールアドレス',
          type: 'warning'
        });
        return
      }

      this.custmor_form.companyAddress = this.level1_item + '/' + this.level2_item + '/' + this.level3_item

      this.axios.post('/custmorForm/save', this.custmor_form)
        .then((res) => {
          if (res.data.code == 200) {
            this.custmor_form.doctorRecommend=0,
            this.custmor_form.doctorProducer=0,
            this.custmor_form.companyName=null,
            this.custmor_form.companyNameKana=null,
            this.custmor_form.companyAddress=null,
            this.custmor_form.companyAddressDetail=null,
            this.custmor_form.companyPhone=null,
            this.custmor_form.companyEmail=null,
            this.custmor_form.commanderName=null,
            this.custmor_form.commanderDepartment=null,
            this.custmor_form.commanderPhone=null,
            this.custmor_form.commanderEmail=null,

            this.level1_item=null,
            this.level2_item=null,
            this.level3_item=null,
            this.level2_array=[],
            this.level3_array=[],

            // this.$message({
            //   message: '送信が完了しました！',
            //   type: 'success'
            // });
            this.$notify({
              title: '成功',
              message: '送信が完了しました！',
              type: 'success'
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  font-family: "PingFang";
}

@font-face {
  font-family: "PingFang";
  src: url("./assets/PingFang Regular.ttf");
}

body {
  font-family: "Bitstream Vera Serif Bold", serif;
}

.custmor_form_side {
  background: rgb(245, 246, 248);
  padding: 20px 0;
}

.custmor_form_fixed {
  width: 768px;
  margin: 0 auto;
}

@media (width <=768px) {
  .custmor_form_fixed {
    width: 100%;
  }
}

.custmor_form_logo {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.custmor_form_logo_style {
  width: 270px;
}

@media (width <=768px) {
  .custmor_form_logo_style {
    width: 140px;
  }
}

.custmor_form_logo_title {
  font-size: 24px;
  font-weight: bold;
}

@media (width <=768px) {
  .custmor_form_logo_title {
    font-size: 14px;
  }
}

.custmor_form_content {
  background: #fff;
  box-shadow: 0 2px 9px 0 hsla(0, 0%, 65%, .5);
}

.custmor_form_head_banner {
  background: rgb(0, 184, 153);
  height: 20px;
}

.custmor_form_head_title {
  font-size: 20px;
  font-weight: bold;
  padding: 30px;
}

.custmor_form_body {
  padding: 30px;
}

.custmor_form_body_widget {
  margin: 24px 0;
}

.custmor_form_widget_line {
  border-top: 1px solid;
  border-color: rgb(200, 205, 212);
}

.custmor_form_body_widget2 {
  width: 74%;
  margin: 24px 0;
  font-weight: bold;
}

@media (width <=768px) {
  .custmor_form_body_widget2 {
    width: 100%;
  }
}

@media (width <=768px) {

  .el-checkbox,
  .el-checkbox__input {
    white-space: normal !important;
  }
}

.el-select {
  width: 37%;
}

.el-cascader {
  width: 77%;
}

.custmor_form_footer {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
